/*! Bookeaz: keep EA cart upsells ('You may also like', "You'll love these") to the seller chosen by the hyperlocal picker.
   Seller = localStorage wk_seller_stores. Each upsell card is matched to its vendor by title via /search/suggest.json.
   Fails open: if no seller is selected, the lookup fails, or the product cannot be matched, the card stays visible. */
(function () {
  'use strict';
  var CARD_SEL = '.easc-sidePanelCard, .easc-carouselUpsell .easc-productRow';
  var TITLE_SEL = '.easc-sidePanelName, .easc-recoTitle';
  var cache = {};
  var timer = null;

  function norm(s) { return String(s || '').toLowerCase().replace(/&/g, 'and').replace(/\.com\b/g, '').replace(/[^a-z0-9]/g, ''); }

  function selected() {
    try {
      var a = JSON.parse(localStorage.getItem('wk_seller_stores') || '[]');
      if (!Array.isArray(a)) a = [a];
      return a.map(norm).filter(Boolean);
    } catch (e) { return []; }
  }

  function vendorsFor(title) {
    var k = title.toLowerCase();
    if (!cache[k]) {
      var u = '/search/suggest.json?q=' + encodeURIComponent(title) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=title,vendor';
      cache[k] = fetch(u, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var ps = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          return ps.filter(function (p) { return String(p.title || '').toLowerCase() === k; })
                   .map(function (p) { return norm(p.vendor); });
        })
        .catch(function () { return null; });
    }
    return cache[k];
  }

  function show(card) { card.style.display = ''; card.style.visibility = ''; }
  function hide(card) { card.style.display = 'none'; }

  function check(card) {
    var sel = selected();
    var t = card.querySelector(TITLE_SEL);
    var title = t ? t.textContent.trim() : '';
    if (!title || !sel.length) { card.removeAttribute('data-bkz-seller'); show(card); return; }
    var stamp = sel.join('|') + '::' + title;
    if (card.getAttribute('data-bkz-seller') === stamp) return;
    card.setAttribute('data-bkz-seller', stamp);
    card.style.visibility = 'hidden';
    var fallback = setTimeout(function () { if (card.getAttribute('data-bkz-seller') === stamp) show(card); }, 4000);
    vendorsFor(title).then(function (vs) {
      clearTimeout(fallback);
      if (card.getAttribute('data-bkz-seller') !== stamp) return;
      var ok = !vs || !vs.length || vs.some(function (v) { return sel.indexOf(v) !== -1; });
      if (ok) show(card); else hide(card);
    });
  }

  function scan() {
    var cards = document.querySelectorAll(CARD_SEL);
    for (var i = 0; i < cards.length; i++) check(cards[i]);
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(scan, 120);
  }

  function start() {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    scan();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
